import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g id="S" transform="translate(25, 23)">
          <path
            d="M 0 31.24 L 3.96 30.525 Q 5.005 37.785 12.925 37.785 Q 21.89 37.785 21.89 30.69 Q 21.89 27.61 20.24 26.125 Q 18.59 24.64 14.74 23.595 L 11.11 22.55 Q 5.445 21.01 3.135 18.618 Q 0.825 16.225 0.825 11.303 Q 0.825 6.38 4.125 3.19 Q 7.425 0 13.723 0 Q 20.02 0 22.88 2.695 Q 25.74 5.39 26.51 10.45 L 22.55 11.165 Q 21.505 3.905 14.19 3.905 Q 5.665 3.905 5.665 11 Q 5.665 14.08 7.178 15.593 Q 8.69 17.105 12.32 18.095 L 16.115 19.14 Q 21.945 20.79 24.338 23.155 Q 26.73 25.52 26.73 30.443 Q 26.73 35.365 23.293 38.528 Q 19.855 41.69 13.338 41.69 Q 6.82 41.69 3.795 38.995 Q 0.77 36.3 0 31.24 Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
